import CMS from 'netlify-cms-app'
import uploadcare from 'netlify-cms-media-library-uploadcare'
import cloudinary from 'netlify-cms-media-library-cloudinary'

import AboutPagePreview from './preview-templates/AboutPagePreview'
import IndexPagePreview from './preview-templates/IndexPagePreview'
import pages from './pages';

window.CMS_MANUAL_INIT = true;

CMS.registerMediaLibrary(uploadcare)
CMS.registerMediaLibrary(cloudinary)

CMS.registerPreviewTemplate('index', IndexPagePreview)
CMS.registerPreviewTemplate('about', AboutPagePreview)


CMS.init({
    config: {
        load_config_file: false,
        backend: {
            name: 'git-gateway',
            branch: 'master',
            commit_messages: {
                create: "Create {{collection}} “{{slug}}”",
                update: "Update {{collection}} “{{slug}}”",
                delete: "Delete {{collection}} “{{slug}}”",
                uploadMedia: "[skip ci] Upload “{{path}}”",
                deleteMedia: "[skip ci] Delete “{{path}}”",
            }
        },
        local_backend: true,
        media_folder: '/static/media',
        public_folder: '/public',
        collections: [pages],
    },
});
